import React from 'react';
import { Col } from 'react-bootstrap';

import styles from './styles.module.scss';

interface TableHeaderProps {
    col: number;
    value: string;
    onClick: () => void;
}

const TableHeader: React.FC<TableHeaderProps> = ({ col, value, onClick }) => {
    if (!value) {
        return <Col md={col} />;
    }
    // !sortOrd && onClick('asc')
    return (
        <Col md={col}>
            <div className={styles.header} onClick={() => onClick()}>
                <p className={styles.label}>{value}</p>

                {/* <div className={cx(styles.sortIcons, { [styles.show]: sortOrd })}>
                    <i
                        className={cx('paperflite-up-arrow', styles.sortIcon, {
                            [styles.active]: sortOrd === 'asc',
                        })}
                        onClick={() => onClick('asc')}
                    />
                    <i
                        className={cx('paperflite-dropdown', styles.sortIcon, {
                            [styles.active]: sortOrd === 'desc',
                        })}
                        onClick={() => onClick('desc')}
                    />
                </div> */}
            </div>
        </Col>
    );
};

export default TableHeader;
